export class FacadeSpacer {
  systemName: string;
  insulationZone: string | null;
  glazingLayer: number | null;
  depth: number | null;
  facadeSpacer1: number | null;
  facadeSpacer2: number | null;
  facadeSpacer3: number | null;
  facadeSpacer11: number | null;
  facadeSpacer21: number | null;
  facadeSpacer22: number | null;
  facadeSpacer23: number | null;
  facadeSpacer31: number | null;
  facadeSpacer41: number | null;
  facadeSpacer51: number | null;
  facadeSpacer52: number | null;
  facadeSpacer61: number | null;
  facadeSpacer71: number | null;
  facadeSpacer72: number | null;
  facadeSpacer81: number | null;
  facadeSpacer82: number | null;
  facadeSpacer83: number | null;
  facadeSpacer84: number | null;
  facadeSpacer85: number | null;
  facadeSpacer91: number | null;
  facadeSpacer92: number | null;
  facadeSpacer93: number | null;
  facadeSpacer101: number | null;
  facadeSpacer111: number | null;
  
  constructor( row: Record<string, string | number | null> ) {
    this.systemName = row['systemName'] as string;
    this.insulationZone = row['insulationZone'] as string | null;
    this.glazingLayer = row['glazingLayer'] as number | null;
    this.depth = row['depth'] as number | null;
    this.facadeSpacer1 = row['facadeSpacer1'] as number | null;
    this.facadeSpacer2 = row['facadeSpacer2'] as number | null;
    this.facadeSpacer3 = row['facadeSpacer3'] as number | null;
    this.facadeSpacer11 = row['facadeSpacer11'] as number | null;
    this.facadeSpacer21 = row['facadeSpacer21'] as number | null;
    this.facadeSpacer22 = row['facadeSpacer22'] as number | null;
    this.facadeSpacer23 = row['facadeSpacer23'] as number | null;
    this.facadeSpacer31 = row['facadeSpacer31'] as number | null;
    this.facadeSpacer41 = row['facadeSpacer41'] as number | null;
    this.facadeSpacer51 = row['facadeSpacer51'] as number | null;
    this.facadeSpacer52 = row['facadeSpacer52'] as number | null;
    this.facadeSpacer61 = row['facadeSpacer61'] as number | null;
    this.facadeSpacer71 = row['facadeSpacer71'] as number | null;
    this.facadeSpacer72 = row['facadeSpacer72'] as number | null;
    this.facadeSpacer81 = row['facadeSpacer81'] as number | null;
    this.facadeSpacer82 = row['facadeSpacer82'] as number | null;
    this.facadeSpacer83 = row['facadeSpacer83'] as number | null;
    this.facadeSpacer84 = row['facadeSpacer84'] as number | null;
    this.facadeSpacer85 = row['facadeSpacer85'] as number | null;
    this.facadeSpacer91 = row['facadeSpacer91'] as number | null;
    this.facadeSpacer92 = row['facadeSpacer92'] as number | null;
    this.facadeSpacer93 = row['facadeSpacer93'] as number | null;
    this.facadeSpacer101 = row['facadeSpacer101'] as number | null;
    this.facadeSpacer111 = row['facadeSpacer111'] as number | null;
  }
}